import { Button, Container, Grid, Typography } from "@mui/material";
import { ArrowForward as ArrowForwardIosIcon } from "@mui/icons-material";
import Header from "../../Header";
import Slider from "react-slick";
import SliderImg from "../../../../assets/image/ezgif.com-resize-1.png";
import SliderImg2 from "../../../../assets/image/ezgif.com-resize-2.png";
import SliderImg3 from "../../../../assets/image/ezgif.com-gif-maker-5.png";
import SliderImg4 from "../../../../assets/image/ezgif.com-gif-maker-1-1.png";
import SliderImg5 from "../../../../assets/image/jjjjlogo.png";
import SliderImg6 from "../../../../assets/image/ezgif.com-gif-maker-10.png";
import SliderImg7 from "../../../../assets/image/ezgif.com-gif-maker-6.png";
import LaptopImg from "../../../../assets/image/web-devloper.png";
import OurTeamImg from "../../../../assets/image/img_box_24.png";
import OurTeamImg2 from "../../../../assets/image/img_box_25.png";
import OurTeamImg3 from "../../../../assets/image/img_box_26.png";
import OurTeamImg4 from "../../../../assets/image/img_box_27.png";
import OurTeamBgImg from "../../../../assets/image/SMM_bg__img-scaled.png";
import WhyChooseImg from "../../../../assets/image/analytics.gif";
import KeyBnifitsImg from "../../../../assets/image/file (2).png";
import FooterSvg from "../../../../assets/image/Untitled-3.svg";
import MobileHeroImg from "../../../../assets/image/mobile-hero-img.png";
import howItWorsImg from "../../../../assets/image/howItWork.png";
import "./MobileAppDev.css";
import Footer from "../../Footer";


const MobileAppDev = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 9,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const ourTeamGridData = [
    {
      id: 1,
      imgSrc: OurTeamImg,
      color: "#695ce8",
      title: "iPhone App Development",
      description:
        "We provide robust PHP web development services to our global clients in UK, USA, and India. Our programmers are well-known for providing custom PHP solutions which are customized to match your unique business requirements.",
    },
    {
      id: 2,
      imgSrc: OurTeamImg2,
      color: "#f47514",
      title: "Android App Development",
      description: `Our PHP website programmers are experts in providing CRM solutions and developing custom features from scratch. Our PHP Development agency ensures that our CRM functionality works perfectly as needed by you.`,
    },
    {
      id: 3,
      imgSrc: OurTeamImg3,
      color: "#ff4a69",
      title: "Flutter App Development",
      description: `Our PHP experts offer cloud services like SaaS, LaaS, PaaS and many more backend solution. We provide full stack PHP web development services from initial consultation, to the final PHP application.`,
    },
    {
      id: 4,
      imgSrc: OurTeamImg4,
      color: "#38c77b",
      title: "React Native Development",
      description: `We provide ecommerce PHP solutions on wordpress, laravel, magento and woocommerce. Our PHP Development company in guwahati  provides full customization services and can help you to add new features to your site .`,
    },
    {
      id: 5,
      imgSrc: OurTeamImg4,
      color: "#38c77b",
      title: "Swift App Development",
      description: `We provide PHP support and maintenance after project completion with 24/7 chat suppport . Our PHP team have worked with small business , large scale enterprise , or any complex business process.`,
    },
    {
      id: 6,
      imgSrc: OurTeamImg3,
      color: "#ff4a69",
      title: "Ionic App Development",
      description: `As a leading PHP application development company, we offer services like custom ERP development on wordpress, Drupal and WordPress. We create custom ERP which are secure, and fast.`,
    },
  ];

  const frontEndDemoData = [
    { id: 1, title: "Javascript", categoryId: 1 },
    { id: 2, title: "Type Script", categoryId: 1 },
    { id: 3, title: "Angular", categoryId: 1 },
    { id: 4, title: "React JS", categoryId: 1 },
    { id: 5, title: "Vue JS", categoryId: 1 },
    { id: 6, title: "Backbone js", categoryId: 1 },
    { id: 7, title: "Emberjs", categoryId: 1 },
    { id: 8, title: "Bootstrap", categoryId: 1 },
    { id: 9, title: "HTML5", categoryId: 1 },
    { id: 10, title: "CSS3", categoryId: 1 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
  ];

  const titleData = [
    {
      id: 1,
      title: "Front End",
    },
    {
      id: 2,
      title: "Back End",
    },
    {
      id: 3,
      title: "Database",
    },
    {
      id: 4,
      title: "Design Tools",
    },
  ];

  const whyChooseUsData1 = [
    { id: 1, desc: "Static website Design starting at Rs. 2999" },
    { id: 2, desc: "Custom Website Designing" },
    { id: 3, desc: "Education Institute Website Design" },
    { id: 4, desc: "School Website Design" },
  ];


  const firstList = [
    { id: 1, name: "Webview Mobile App Development starting at Rs. 2999" },
    { id: 2, name: "Custom Mobile App Development" },
    { id: 3, name: "E-commerce Mobile App Development" },
    { id: 4, name: "GYM Mobile App Development" },
    { id: 5, name: "Fitness Center Mobile App Development" },
    { id: 6, name: "Company Mobile App Development" },
    { id: 7, name: "Small Business Mobile App Development" },
    { id: 8, name: "Business Mobile App Development" },
    { id: 9, name: "Corporate Mobile App Development" },
    { id: 10, name: "Tea Garden Mobile App Development" },
    { id: 11, name: "Real Estate Mobile App Development" },
    { id: 12, name: "Taxi Booking Mobile App Development" },
    { id: 13, name: "Education Institute Mobile App Development" },
    { id: 14, name: "School Mobile App Development" },
    { id: 15, name: "University Mobile App Development" },
    { id: 16, name: "College Mobile App Development" }
  ];

  const secondList = [
    { id: 1, name: "News Channel Mobile App Development" },
    { id: 2, name: "News Portal Mobile App Development" },
    { id: 3, name: "TV Channel Mobile App Development" },
    { id: 4, name: "Hotel Mobile App Development" },
    { id: 5, name: "Restaurant Mobile App Development" },
    { id: 6, name: "Fashion Mobile App Development" },
    { id: 7, name: "Wedding Android App Development" },
    { id: 8, name: "Festival Android, iOS App Development" },
    { id: 9, name: "CMS (Joomla, WordPress, Drupal) Mobile App" },
    { id: 10, name: "Community Forum Mobile App Development" },
    { id: 11, name: "Travel Mobile App Development" },
    { id: 12, name: "Government Mobile App Development" },
    { id: 13, name: "Custom CMS Mobile App Development" },
    { id: 14, name: "Mobile App Development with Payment Gateway Integration" },
    { id: 15, name: "Mobile App Makeover" },
    { id: 16, name: "Mobile App Development New UI/UX Design Development" }
  ];

  return (
    
  <>
    <Header />
    <section style={{ paddingTop: "30px" }}>
      <Container>
        <Grid container spacing={0}>
          <Grid item xs={12} md={6}>
            <div className="text-uppercase text-bold">
              What We Do
            </div>
            <br />
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                textTransform: "uppercase",
                fontWeight: "bold",
                color: "#3a506b",
              }}
            >
              We are Mobile App Development Company to Design & Develop Your Custom Mobile Application.
            </Typography>
            <br />
            <br />
            <img src={MobileHeroImg} />
          </Grid>
          <Grid item xs={12} md={6}>
            <Grid container spacing={4}>
              {ourTeamGridData.map((item, index) => (
                <Grid item xs={12} md={6} key={item.id} className="mobile-dev-hero-grid">
                  <div style={{ display: "flex", padding: "0px" }}>
                    {/* <img
                    src={item.imgSrc}
                    width={50}
                    height={50}
                    alt="Placeholder 1"
                    style={{ marginRight: "10px" }}
                  /> */}
                    <div>
                      <div
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          color: '#f47514',
                        }}
                      >
                        {"0" + item.id}
                        <br />
                        <span style={{ color: 'black' }}>{item.title}</span>
                      </div>
                      <p
                        className="our-team-card-description"
                        style={{
                          fontSize: "16px",
                          color: "#8d99ae",
                          marginTop: "0",
                        }}
                      >
                        {item.description}
                      </p>
                    </div>
                  </div>
                </Grid>
              ))}

            </Grid>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                style={{
                  padding: "15px 25px 15px 25px",
                  background: "#6254e7",
                  color: "white",
                  marginBottom: "20px",
                }}
                variant="contained"
                color="#7209b7"
              >
                Discover More
              </Button>
            </div>
          </Grid>
        </Grid>
      </Container>
    </section>

    <section>
      <Container>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            textTransform: "uppercase",
            fontSize: "17px",
          }}
        >
          <h3 style={{ fontWeight: "bold" }}>Our Happy Clients</h3>
        </div>
        <div className="slider-container">
          <Slider {...settings}>
            <div>
              <img width={70} src={SliderImg} alt="Client 1" />
            </div>
            <div>
              <img width={70} src={SliderImg2} alt="Client 2" />
            </div>
            <div>
              <img width={70} src={SliderImg3} alt="Client 3" />
            </div>
            <div>
              <img width={70} src={SliderImg4} alt="Client 4" />
            </div>
            <div>
              <img width={70} src={SliderImg5} alt="Client 5" />
            </div>
            <div>
              <img width={70} src={SliderImg6} alt="Client 6" />
            </div>
            <div>
              <img width={70} src={SliderImg7} alt="Client 6" />
            </div>
          </Slider>
        </div>
      </Container>
    </section>

    {/* video section  */}


    {/* video section  */}

    <section>
      <Container>
        <p className="text-uppercase text-bold">We at Reseller Bano as a</p>
        <p className="ts-18">
          We are among the top Mobile App Development Services in Guwahati that can create any type of Mobile Application you want. Our Android Developers have already created many Applications for different types of clients. You check our portfolio to see all of the work that we have done so far. And even after the Application is released we are here to provide you with the best service you can get. Our Android Developer is always ready to help you with your application any time you want.
        </p>
      </Container>
    </section>


    <section>
      <Container>
        <Grid container spacing={0}>
          <Grid item xs={12} md={5}>
            <div style={{ textTransform: "uppercase", fontWeight: "bold" }}>
              How It Works
            </div>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#3a506b" }}
            >
              End-to-End Mobile App Development Services for iOS, Android and Cross-platform
            </Typography>
            <p style={{ fontSize: "20px" }}>
              We have been providing world-class mobile app development services for Startups, mid-scale businesses, and enterprises since 2011. Our highly skilled mobile app developers will work on transforming your app idea into an innovative and secure mobile application.
            </p>
            <div>
              <Grid container spacing={5}>

                {ourTeamGridData.map((item, index) => (
                  <Grid item xs={12} md={6} key={item.id} className="">
                    <div style={{ display: "flex", padding: "0px" }}>
                      {/* <img
                    src={item.imgSrc}
                    width={50}
                    height={50}
                    alt="Placeholder 1"
                    style={{ marginRight: "10px" }}
                  /> */}
                      <div>
                        <div
                          style={{
                            fontSize: "16px",
                            color: '#3b3663',
                          }}
                        >
                          <span style={{ fontWeight: 'bold' }}>{"0" + item.id}</span>
                          <br />
                          <span style={{ color: '#8d99ae' }}>{item.title}</span>
                        </div>

                      </div>
                    </div>
                  </Grid>
                ))}

              </Grid>

            </div>
          </Grid>
          <Grid item xs={12} md={7}>
            <img src={howItWorsImg} />
          </Grid>
        </Grid>
        {/* <Grid container spacing={0}>
          <Grid item xs={12} md={6}></Grid>
          <Grid item xs={12} md={6}>
            <p style={{ textTransform: "uppercase", textAlign: "center" }}>
              Web development services
            </p>
          </Grid>
          <p style={{ fontSize: "20px" }}>
            Reseller Bano, one of the{" "}
            <a href="#">
              Top Web Design Company in Guwahati, Assam
            </a>
            , India Our customers are companies of all sizes ranging from
            start-ups to large enterprises who realize that they need a
            professional internet solution to set up revenue streams, build
            communication channels or streamline business operations. Our core
            competency is to promote your business online, to create online
            business opportunities and leads, and to empower your business. We
            are one of the best and Supportive website Design and Developers
            in the Guwahati, Assam, If you are looking for most affordable,
            creative, Reliable Professional website.
          </p>
        </Grid> */}

      </Container>

    </section>

    <section>
      <Container>
        <Typography
          variant="p"
          gutterBottom
          sx={{ fontWeight: "bold", color: "black" }}
          className="text-uppercase text-bold"
        >
          Reseller Bano Offers Exceptional Quality Mobile Application
        </Typography>
        <Typography
          variant="h5"
          gutterBottom
          sx={{ fontWeight: "bold", color: "#3a506b" }}

        >
          We Specialize in
        </Typography>
        <div>
          <Grid container spacing={5}>
            <Grid item xs={12} md={6}>
              <ul>
                {firstList.map((item, index) => (
                  <li style={{ listStyle: 'none', fontSize: '16px', padding: '0 0 9px' }}>
                    <span style={{ color: '#6254e7' }}>{item.id}</span>. {item.name}
                  </li>
                ))}
              </ul>
            </Grid>
            <Grid item xs={12} md={6}>
              <ul>
                {secondList.map((item, index) => (
                  <li style={{ listStyle: 'none', fontSize: '16px', padding: '0 0 9px' }}>
                    <span style={{ color: '#6254e7' }}>{item.id}</span>. {item.name}
                  </li>
                ))}
              </ul>
            </Grid>
          </Grid>
        </div>
      </Container>
    </section>


    <section style={{
      backgroundImage: `url(${OurTeamBgImg})`,
      backgroundPosition: "center center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      padding: "20px",
    }}>
      <Container>
        <div
          style={{
            textAlign: "center",
            backgroundImage:
              "linear-gradient(80deg, #de6262 8%, #ffb88c 82%)",
            padding: "20px",
            color: "#fff",
            borderRadius: "20px",
            boxShadow: "0px 0px 19px 0px rgba(0,0,0,.5)",
          }}
        >
          <p className="text-uppercase text-bold">Welcome</p>
          <Typography
            variant="h4"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#fff" }}
            className="let-discuss-header"
          >
            Let's Discuss Your Project
          </Typography>
          <p className="let-discuss-para" style={{ fontSize: "18px" }}>
            We accept Mobile Application Development projects including Mobile
            App UI/UX Design from all major towns and cities of Assam
            including Guwahati, Silchar, Dibrugarh, Tezpur, Tinsukia,
            Bongaigaon, Mangaldai, Nalbari, Pathsala, Nagaon, Jorhat,
            Sivasagar, Lakhimpur, Dhekiajuli. We haved expanded our services
            to multiple cities of Northeast including Itanagar, Arunachal
            Pradesh, Imphal, Manipur, Shillong, Meghalaya, Aizawl, Mizoram,
            Agartala, Tripura, Kohima, Nagaland
          </p>
          <Button
            style={{
              padding: "15px 25px 15px 25px",
              background: "#fff",
              color: "black",
              borderRadius: "40px",
            }}
            variant="contained"
            color="#7209b7"
            className="text-uppercase"
          >
            Talk our experts
          </Button>
        </div>
      </Container>
    </section>


    <section>
      <Container>
        <p className="text-uppercase text-bold">We are one of the top</p>
        <Typography
          variant="h4"
          gutterBottom
          sx={{ fontWeight: "bold", color: "#3b3663" }}
          className="let-discuss-header"
        >
          Mobile App Development Services in Assam
        </Typography>
        <p className="ts-18">
          with a team of skilled Developers concentrated on latest Android Java and Kotlin, iOS, React Native, NodeJS and other JavaScript Libraries and many other. Mobile app development indeed nowadays necessary for all the business. We, as a very well-known mobile application development company can provide high quality standard mobile app of any category. We have worked with diverse brands, organizations, start-ups and individuals to create powerful apps from excellent idea. Now a days, your mobile app is one of the foundations of your presence in the Internet, it should be look and feel professional for strong presence over your competitors. Our main focus, as a mobile app development company is to provide strategic planning & industry’s best product to compete in the market.
        </p>
      </Container>
    </section>


    <section>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <p className="text-uppercase text-bold">Hot It Works</p>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#3a506b" }}
              className="let-discuss-header"
            >
              We are Exclusive Solution Agency
            </Typography>
            <p className="ts-18">
            Build Your Next-Gen Mobile Apps with Our Flutter App Development Services
            </p>
            <p className="ts-18">
              As people spend more than 8 hours a day searching on the
              Internet, every business should have a web presence. Having a
              website for any type of business offers plenty of benefits. Here
              are some crucial reasons to develop a website for your business:
            </p>
            <Button
                style={{
                  padding: "15px 25px 15px 25px",
                  background: "linear-gradient(96deg,#6254e7 0%,#9289f1 100%)",
                  color: "white",
                  marginBottom: "20px",
                }}
                variant="contained"
                color="#7209b7"
              >
                Discover More
              </Button>
          </Grid>
          <Grid item xs={12} md={6}>
            <img src={KeyBnifitsImg} alt="Reseller Bano Key Benefits" />
          </Grid>
        </Grid>

        <p className="text-uppercase text-bold" >We at Reseller Bano as a</p>
        <p className="ts-18"><a href="https://resellerbano.com">leading Mobile App Development Services in Guwahati, Assam</a>, we strategies your plan and apply necessary methodology to create a perfect app for your business. We have served more than 100 customers, they are benefited from the quality services that we give. Right from the start, we harness the latest and best tools, SDKs, and frameworks to ensure our mobile app development services cater for iPad, iPhone and Android. Android – Java, Kotlin, iOS – Swift, Ionic, Angular, Node.js, PhoneGap App Development are some of the latest technologies we use. With latest cutting-edge technologies, we are well versed in creating design and development of native mobile applications as well as hybrid or WebView, which made the cost of application low and leverage the full potential of the technology.</p>
        <p className="ts-18">
        Apps we build showcase only a portion of what our mobile app development team is capable of. We know what it takes to convert your vision into reality. Having worked on numerous projects, we understand every app project is different and needs special attention. Thus, we spend a considerable time in planning and research. If you are looking for most affordable, creative, Reliable Professional Looking Mobile Application your are on the right website. OZOSOFT, one of the well-known Company in Guwahati, Assam, India our customers are companies of all sizes ranging from start-ups to large enterprises who realize that they need a professional application solution to set up revenue streams, build communication channels or streamline business operations. We are one of the best and Supportive Developers in the Guwahati, Assam for us, creativity is nothing but a way to solve old problems in new ways.
        </p>
        <img src={FooterSvg} />
      
      </Container>
    </section>


    <Footer/>

  </>
   

  )
}

export default MobileAppDev
